import React from 'react';

export const OverflowContent = ({ children }) => {
  return (
    <div className="p-10 overflow-y-auto h-fit relative z-[100] text-left">
      {children}
    </div>
  );
};
